<template>
<div class="small-12 medium-12 large-12 columns">
  <div class="row documento_dados">
    <div class="small-4 medium-8 large-6 columns show-for-large">
      <div class="row">
        <div class="small-12 medium-4 large-2 columns ano_doc_legislacao">
          <h3>{{ item.doc_ano }}</h3>
        </div>
        <div class="small-8 medium-8 large-10 columns">
          <h3>{{ item.doc_titulo }}</h3>
        </div>
      </div>
    </div>
    <div class="small-12 medium-12 large-6 columns">
      <div class="row">
        <div class="small-12 medium-10 large-12 columns">
          <template v-for="file in item.doc_ficheiros">
            <div class="row" v-if="file.doc_ficheiros_nome.length > 0 && file.doc_ficheiros_url.length > 0">
              <div class="small-1 medium-1 large-1 columns img_icon_doc">
                <a :href="file.doc_ficheiros_url">
                  <img :src="iconPdfUrl" class="pdf_icon">
                </a>
              </div>
              <div class="small-10 medium-10 large-11 columns descarregar_doc">
                <a target="_blank" :href="file.doc_ficheiros_url">
                  {{ file.doc_ficheiros_nome }}
                </a>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: ["item"],
  setup() {
    const iconPdfUrl = 'https://www.uma.pt/wp-content/themes/uma/images/icon_pdf_cinza.png';

    return {
      iconPdfUrl
    }
  }
}
</script>

<style scoped>
.columns {
  padding-left: 0;
  padding-right: 0;
}

.documento_dados {
    border-bottom: 1px solid #a7a5a5
}

.documento_dados_designacao {
  border-bottom: 1px solid #a7a5a5;
}

.documento_dados_designacao .columns,
.documento_dados .columns {
  padding-left: 0
}

.documento_dados_designacao .row .columns {
  padding-left: 0
}

.documento_dados_designacao h3 {
  font-size: 12px;
  font-family: "Montserrat";
  text-transform: uppercase;
  color: #707475
}

.documento_dados:first-of-type {
  word-break: break-word
}

.documento_dados .columns .columns {
  padding-right: 7px;
  padding-top: 7px;
  padding-bottom: 7px
}

.documento_dados h3 {
  font-family: "Montserrat";
  font-size: 15px;
  padding-top: 16px;
  color: #707475;
  padding-right: 20px
}

.ano_doc_legislacao h3 {
  font-family: "Montserrat" !important;
  color: #707475 !important;
}

.documento_dados .columns:last-of-type .columns:last-of-type {
  padding-right: 0 !important;
}

.descarregar_doc a {
  font-size: 15px;
  padding-left: 5px;
  display: block;
  padding-top: 7px;
  font-family: "Montserrat Bold";
  color: #707475;
}

.img_icon_doc a img {
    width: 28px
}

@media screen and (max-width: 767px) {
  .row.documento_dados{
    border: 0;
  }  

  .documento_dados .columns .columns{
    padding-top: 7px;
    padding-bottom: 0;
    padding-left: 0px;
  }
}
</style>